import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { InputBaseComponentProps } from '@fairstone/ui/core';

interface TextMaskCustomType extends InputBaseComponentProps {
    definitions: Record<string, string | RegExp>;
    mask: string;
    name: string;
    onChange: (e: any) => void;
    other: any;
}

const TextMaskCustom = forwardRef(function TextMaskCustom(props: TextMaskCustomType, ref: any) {
    const { definitions, mask, name, onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            definitions={definitions}
            inputRef={ref}
            mask={mask}
            onAccept={(value) => onChange({ target: { name, value } })}
            overwrite
        />
    );
});

export default TextMaskCustom;
